import { Translation, QRType } from '../types';

export const it: Translation = {
  nav: {
    generator: 'Generatore',
    scanner: 'Scanner',
    mobile: 'Provalo su mobile',
    blog: 'Blog',
    langSelect: 'Seleziona lingua',
  },
  pageTitles: {
    generator: 'Generatore di QR Code Gratis Online',
    scanner: 'Scanner QR Code Online',
    textToQr: 'Convertitore Testo in QR Code',
    linkToQr: 'Generatore di QR Code per Link',
  },
  pageMeta: {
    generator: {
      title:
        'Generatore di QR Code Gratis — Crea QR Online (Nessuna Registrazione, Nessun Watermark, PNG/SVG/PDF) | YesQRCode',
      description:
        'Crea codici QR online gratuitamente con YesQRCode. Genera URL, testo, Wi-Fi, vCard e altro. Scarica PNG, SVG o PDF ad alta qualità. Nessuna registrazione, nessun login, nessun watermark — veloce, sicuro e sempre gratuito.',
      keywords: [
        'generatore di qr code',
        'generatore qr gratis',
        'crea qr code online',
        'creatore di qr',
        'qr code png',
        'qr code svg',
        'qr code pdf',
        'generatore qr wifi',
        'generatore qr vcard',
        'generatore qr senza registrazione',
      ],
    },
    scanner: {
      title:
        'Scanner QR Code Online — Scansiona da Immagine o Fotocamera (Sicuro, Senza Registrazione) | YesQRCode',
      description:
        'Scansiona codici QR e barcode online gratuitamente. Carica un’immagine o usa la fotocamera. Tutto viene elaborato localmente senza upload. Sicuro, veloce, senza registrazione, senza login e completamente gratuito.',
      keywords: [
        'scanner qr code',
        'scansionare qr online',
        'lettore qr online',
        'scansiona qr da immagine',
        'scanner barcode online',
        'scanner qr sicuro',
        'scanner qr senza upload',
        'scanner qr gratis',
        'scanner qr da browser',
        'scanner qr senza registrazione',
        'scanner qr senza login',
      ],
    },
  },
  hero: {
    title: 'Genera. Scansiona. Crea.',
    subtitle: 'Lo strumento QR premium per professionisti e creator.',
    desc: 'Genera codici QR personalizzati con loghi, colori e file ad alta risoluzione in pochi secondi.',
  },
  info: {
    helpTitle: 'Centro assistenza',
    helpSubtitle: 'Domande frequenti e supporto',
    contactTitle: 'Contattaci',
    contactSubtitle: 'Rispondiamo rapidamente.',
    privacyTitle: 'Informativa privacy',
    termsTitle: 'Termini di servizio',
  },
  contactForm: {
    name: 'Nome',
    email: 'Email',
    message: 'Messaggio',
    send: 'Invia messaggio',
    orEmail: 'oppure scrivi a',
    sending: 'Invio in corso...',
    successTitle: 'Messaggio inviato!',
    successMessage: 'Ti risponderemo al più presto.',
    sendAnother: 'Invia un altro messaggio',
    errorMessage: 'Non riusciamo a inviare il messaggio ora. Scrivici a support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Crea QR code privati e pronti per il brand — gratis per sempre.',
      subtitle: 'Uno strumento QR veloce, riservato e flessibile per ogni flusso di lavoro.',
      desc: 'Genera e scansiona QR di alta qualità senza account, watermark o caricamenti di dati.',
      items: [
        {
          title: 'Privacy prima di tutto, generazione locale',
          desc: 'I QR vengono creati in locale — niente upload, tracciamenti o archiviazioni.',
        },
        {
          title: 'Funzioni ricche per ogni esigenza',
          desc: 'URL, Wi-Fi, vCard, codici a barre, loghi, gradienti e cornici già integrati.',
        },
        {
          title: 'Esperienza ottimizzata per il mobile',
          desc: 'Ottimizzato per smartphone e interazioni touch per creare e scansionare senza attriti.',
        },
        {
          title: 'Gratis per sempre e sicuro per l’uso commerciale',
          desc: 'Nessun account, watermark o limite di scansioni — affidabile per team e brand.',
        },
      ],
    },
    featureSuite: {
      title: 'La suite completa di QR orientata alla privacy',
      subtitle: 'Tutto ciò che serve per creare QR puliti, brandizzati e di alta qualità in un unico posto.',
      categories: [
        {
          title: 'Tutti i tipi di QR di cui hai bisogno',
          body: 'URL, testo, Wi-Fi, email, telefono, SMS, vCard, link social, YouTube e codici a barre. Codici statici che non scadono mai.',
          items: [],
        },
        {
          title: 'Branding & design',
          body: 'Codici sicuri per i loghi, gradienti, cornici, forme, angoli e layout ottimizzati per la scansione.',
          items: [],
        },
        {
          title: 'Output & qualità',
          body: 'Export PNG, SVG e PDF ad alta risoluzione con preset per stampa e digitale.',
          items: [],
        },
        {
          title: 'Globale & usabilità',
          body: 'Interfaccia multilingue, design mobile-first e flussi che funzionano anche offline.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Trusted by creators, teams, and brands',
      subtitle:
        'YesQRCode is designed to be lightweight, predictable, and safe for long-running campaigns — with no accounts, no vendor lock-in, and no hidden limitations.',
      items: [
        'Zero onboarding',
        'Predictable static codes',
        'Enterprise-safe: no cloud processing',
        'Consistent branding across all assets',
      ],
    },
    sectionContent: 'Contenuto',
    sectionColors: 'Colori',
    sectionLogo: 'Logo',
    sectionFrame: 'Cornice',
    sectionDesign: 'Design',
    sectionCorrection: 'Correzione errore',
    labelUrl: 'URL del sito',
    labelText: 'Testo semplice',
    labelSsid: 'Nome rete (SSID)',
    labelPassword: 'Password',
    labelEncryption: 'Cifratura',
    labelFgColor: 'Colore principale',
    labelBgColor: 'Colore sfondo',
    labelFrameText: 'Testo cornice',
    labelFrameColor: 'Colore cornice',
    placeholder: 'Inserisci qui il contenuto...',
    placeholders: {
      url: 'https://esempio.it',
      text: 'Scrivi il testo',
      email: 'nome@email.it',
      subject: 'Oggetto',
      message: 'Il tuo messaggio...',
      phone: '+39 320 0000000',
      ssid: 'LaMiaRete',
      password: 'Password',
      barcode: '123456789012',
    },
    download: 'Scarica PNG',
    downloadSvg: 'Scarica SVG',
    generateButton: 'Genera QR Code',
    copy: 'Copia SVG',
    uploadLogo: 'Carica immagine',
    preview: 'Anteprima',
    lowQuality: 'Bassa qualità',
    highQuality: 'Alta qualità',
    foreverFree: 'Gratis per sempre • Nessuna registrazione • Uso commerciale consentito',
    barcodeWarning: 'Le opzioni di logo e cornice non sono disponibili per i codici a barre.',
    barcodeColors: 'Puoi comunque personalizzare i colori qui sotto.',
    frameStyles: {
      none: 'Nessuna cornice',
      simple: 'Semplice',
      balloon: 'Fumetto',
      box: 'Box',
      badge: 'Badge',
      polaroid: 'Polaroid',
      phone: 'Telefono',
      header: 'Header',
      corner: 'Angoli',
    },
    vCard: {
      firstName: 'Nome',
      lastName: 'Cognome',
      mobile: 'Cellulare',
      phone: 'Telefono',
      fax: 'Fax',
      email: 'Email',
      company: 'Azienda',
      job: 'Ruolo',
      street: 'Via',
      city: 'Città',
      zip: 'CAP',
      state: 'Provincia',
      country: 'Paese',
      website: 'Sito web',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Testo',
      [QRType.EMAIL]: 'Email',
      [QRType.PHONE]: 'Telefono',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi-Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Codice a barre',
    },
    guide: {
      title: 'Come creare un QR Code personalizzato',
      steps: [],
    },
    gettingStarted: {
      title: '4 passaggi rapidi',
      steps: [
        {
          title: 'Definisci il contenuto',
          text: 'Scegli il tipo di QR e compila tutti i campi che dovranno apparire dopo la scansione.',
        },
        {
          title: 'Personalizza lo stile',
          text: 'Modifica colori, forme e logo per allineare il QR alla tua brand identity.',
        },
        {
          title: 'Genera il codice',
          text: 'Imposta la risoluzione, guarda l’anteprima in tempo reale e prova il codice con lo scanner integrato.',
        },
        {
          title: 'Scarica e utilizza',
          text: 'Esporta il file in PNG o SVG pronto per stampa, packaging o campagne digitali.',
        },
      ],
    },
    about: {
      title: 'Il generatore di QR gratuito con qualità professionale',
      subtitle:
        'YesQRCode offre esportazioni nitide, controlli grafici avanzati e QR statici senza scadenza.',
      features: [
        'QR per social e landing page',
        'vCard digitale',
        'Colori e forme personalizzabili',
        'File pronti per la stampa',
        'Uso commerciale incluso',
        'Scansioni illimitate',
      ],
      content: [
        {
          title: 'Validità illimitata',
          body: 'I QR statici non scadono e possono essere riutilizzati nel tempo senza costi extra.',
        },
        {
          title: 'Logo senza compromessi',
          body: 'Sfrutta fino al 30% di correzione errore per inserire il logo mantenendo la massima leggibilità.',
        },
        {
          title: 'Design flessibile',
          body: 'Configura moduli, gradienti e cornici per ottenere codici accattivanti e coerenti con la tua grafica.',
        },
        {
          title: 'Pronto per la stampa',
          body: 'Scarica PNG in alta risoluzione o SVG vettoriale per manifesti, volantini e imballaggi.',
        },
        {
          title: 'Uso commerciale libero',
          body: 'Integra i codici in prodotti, campagne OOH e materiali promozionali senza vincoli.',
        },
      ],
    },
    faq: {
      title: 'Domande frequenti',
      items: [
        {
          q: 'Cos’è un QR Code?',
          a: 'Un codice bidimensionale che può contenere link, testo o altre informazioni facilmente scansionabili.',
        },
        {
          q: 'Il servizio è gratuito?',
          a: 'Sì, puoi creare tutti i QR che desideri per uso personale o aziendale.',
        },
        {
          q: 'Posso modificare il QR dopo la stampa?',
          a: 'I codici sono statici: se vuoi cambiare il contenuto devi generarne uno nuovo.',
        },
        {
          q: 'Esistono limiti di scansione?',
          a: 'No, i QR possono essere scansionati infinite volte.',
        },
        {
          q: 'I miei dati sono al sicuro?',
          a: 'Conserviamo le immagini solo temporaneamente per velocizzare il download.',
        },
        {
          q: 'La vCard non viene letta correttamente.',
          a: 'Alcune app non seguono lo standard vCard: prova con un altro lettore.',
        },
        {
          q: 'Il codice non funziona, cosa faccio?',
          a: 'Controlla URL, contrasto dei colori e prova a rimuovere il logo.',
        },
        {
          q: 'Quali browser sono supportati?',
          a: 'Chrome, Firefox, Safari ed Edge aggiornati funzionano perfettamente.',
        },
      ],
    },
  },
  scanner: {
    title: 'Scanner QR e barcode',
    subtitle: 'Scansiona tramite camera, caricamento immagine o incolla da clipboard.',
    cameraPermission: 'Abilita l’accesso alla camera nelle impostazioni del browser.',
    result: 'Risultato',
    copy: 'Copia',
    copied: 'Copiato',
    open: 'Apri link',
    delete: 'Elimina',
    scanAgain: 'Scansiona ancora',
    privacy: 'L’elaborazione avviene sul tuo dispositivo; nessun file viene inviato ai nostri server.',
    upload: 'Carica immagine',
    paste: 'Incolla (Ctrl+V)',
    drop: 'Trascina qui l’immagine',
    retry: 'Riprova',
    errorAccessDenied: 'Accesso camera negato',
    errorCamera: 'Concedi l’autorizzazione alla camera e riprova.',
    initializing: 'Inizializzazione camera...',
    cameraActive: 'Camera attiva',
    scannedItems: 'Cronologia scan',
    recentScans: 'Recenti (solo locale)',
    clickToUpload: 'Clicca per caricare',
    newBadge: 'NOVITÀ',
    tabCameraMobile: 'Camera',
    tabCameraDesktop: 'Scanner tramite camera',
    emptyState: {
      title: 'Nessuna scansione',
      desc: 'Carica un’immagine o passa alla scheda camera per iniziare.',
    },
    highlights: {
      title: 'Scansione rapida e privata',
      items: [
        { title: 'Decodifica sul dispositivo', desc: 'Nessun upload di default; sicura per URL e asset sensibili.' },
        { title: 'Multi-formato', desc: 'QR più UPC/EAN, Code 128, ITF e altri standard.' },
        { title: 'Azioni veloci', desc: 'Trascina file, incolla screenshot o passa subito alla scansione live.' },
        { title: 'Ottimo su mobile', desc: 'UI e flusso della fotocamera ottimizzati per telefoni e schermi piccoli.' },
      ],
    },
    intro: {
      title: 'Scanner online sicuro',
      body: 'Decodifica QR, UPC, EAN, ITF e molti altri formati direttamente dal browser.',
    },
    howTo: {
      title: 'Come funziona',
      methods: [
        { title: 'Caricamento immagine', steps: ['Clic su “Carica immagine”', 'Seleziona il file', 'Ottieni il risultato immediato'] },
        { title: 'Modalità camera', steps: ['Apri la scheda camera', 'Concedi l’autorizzazione', 'Inquadra il codice finché viene letto'] },
      ],
    },
    features: {
      title: 'Perché usarlo',
      items: [
        { title: 'Gratis e illimitato', desc: 'Nessun paywall, nessun watermark.' },
        { title: 'Multi-formato', desc: 'Supporta QR, Code 128, EAN, UPC, ITF ecc.' },
        { title: 'Privacy', desc: 'I file restano sul tuo dispositivo.' },
      ],
    },
    useCases: {
      title: 'Casi d’uso',
      items: [
        { title: 'Marketing e retail', desc: 'Verifica materiali stampati e coupon digitali.' },
        { title: 'Logistica e magazzino', desc: 'Controlla rapidamente barcode e etichette.' },
        { title: 'Uso quotidiano', desc: 'Apri menù, reti Wi-Fi o moduli in sicurezza.' },
      ],
    },
    faq: {
      title: 'FAQ scanner',
      items: [
        { q: 'Legge i codici a barre?', a: 'Sì, supportiamo i principali formati 1D e 2D.' },
        { q: 'Posso incollare screenshot?', a: 'Certo, usa Ctrl+V (o Cmd+V su Mac).' },
        { q: 'I risultati vengono salvati?', a: 'Rimangono solo sul tuo browser e puoi cancellarli quando vuoi.' },
        { q: 'Funziona offline?', a: 'Il caricamento immagine sì; la camera richiede permessi e supporto hardware.' },
      ],
    },
  },
  blog: {
    title: 'Idee e guide',
    subtitle: 'Best practice, spunti creativi e novità sul mondo dei QR Code.',
    readMore: "Leggi l'articolo",
    back: 'Torna al blog',
    notFound: 'Articolo non trovato',
  },
  common: {
    footer: 'La suite definitiva per creare e gestire QR Code professionali.',
    privacy: 'Privacy',
    terms: 'Termini',
    contact: 'Contatti',
    scanToOpen: 'Scansiona per aprire sul telefono',
    help: 'Supporto',
    free: 'Gratis',
    product: 'Prodotto',
    resources: 'Risorse',
    company: 'Azienda',
    api: 'API (presto disponibile)',
    systemStatus: 'Sistema operativo regolare',
    footerDesc:
      'YesQRCode è il modo più veloce per progettare QR affidabili: sicuro, veloce e gratuito per creator, brand e agenzie.',
  },
};
